<template>
  <div>
    <div class="d-flex justify-space-between align-center mb-4">
      <h5 class="text-h6 mb-0">Office Overview</h5>
      <v-menu offset-y right>
        <template #activator="{ on, attrs }">
          <v-chip small outlined color="primary" v-bind="attrs" v-on="on">
            {{ selectedTimeframeLabel }}
            <v-icon small right>mdi-chevron-down</v-icon>
          </v-chip>
        </template>
        <v-list dense>
          <v-list-item
            v-for="option in timeframeOptions"
            :key="option.value"
            @click="selectTimeframe(option.value)"
          >
            <v-list-item-title>{{ option.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <v-row v-if="loading">
      <v-col v-for="n in 5" :key="n" class="pa-1">
        <v-skeleton-loader
          class="metric-card-placeholder"
          type="card"
          :height="isMobile ? 146 : 192"
        />
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col v-for="stat in statCards" :key="stat.key" class="d-flex pa-1">
        <v-card
          outlined
          hover
          class="metric-card transition-swing d-flex flex-column"
        >
          <v-card-text class="text-center pa-4 pa-sm-6">
            <v-avatar
              :size="isMobile ? 44 : 56"
              :color="stat.color + ' lighten-5'"
              class="mb-3"
            >
              <v-icon color="primary" :size="isMobile ? 22 : 28">
                {{ stat.icon }}
              </v-icon>
            </v-avatar>
            <div class="text-h4 font-weight-bold mb-1 appMain--text">
              {{ getStatForKey(stat.key) }}
            </div>
            <div class="text--secondary font-weight-medium text-body-2">
              {{ stat.label }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

const TIMEFRAME_OPTIONS = [
  { text: 'Last hour', value: 'h1' },
  { text: 'Last 24 hours', value: 'h24' },
  { text: 'Last 7 days', value: 'd7' },
];

const STAT_CARDS = [
  {
    icon: 'mdi-account-plus',
    label: 'Contacts Added',
    key: 'contacts_created',
  },
  { icon: 'mdi-phone', label: 'Called', key: 'received_call' },
  { icon: 'mdi-message-text', label: 'Texted', key: 'received_sms' },
  { icon: 'mdi-account-multiple', label: 'Reached', key: 'contacts_reached' },
  {
    icon: 'mdi-calendar-check',
    label: 'Interview Scheduled',
    key: 'interview_scheduled',
  },
];

export default {
  name: 'RecruitingOfficeOverview',
  data() {
    return {
      loading: true,
      selectedTimeframe: 'h24',
      timeframeOptions: TIMEFRAME_OPTIONS,
      statCards: STAT_CARDS,
      stats: {
        contacts_created: 0,
        contacts_reached: 0,
        received_call: 0,
        received_sms: 0,
        interview_scheduled: 0,
      },
    };
  },
  computed: {
    selectedTimeframeLabel() {
      const option = this.timeframeOptions.find(
        (o) => o.value === this.selectedTimeframe
      );
      return option ? option.text : '';
    },
  },
  methods: {
    ...mapActions('vector', ['loadRecruitingActivityReport']),

    getStatForKey(key) {
      if (!key || !this.stats) return 0;
      return this.stats[key] || 0;
    },

    selectTimeframe(value) {
      if (this.selectedTimeframe === value) return;
      this.selectedTimeframe = value;
      this.fetchStats();
    },

    async fetchStats() {
      this.loading = true;
      try {
        const res = await this.loadRecruitingActivityReport({
          timeframe: this.selectedTimeframe,
        });
        const results = res?.data?.results || res?.data || [];
        const data = Array.isArray(results) ? results[0] || {} : {};
        for (const statKey in this.stats) {
          this.stats[statKey] = data[statKey] || 0;
        }
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchStats();
  },
};
</script>

<style lang="less">
.metric-card {
  border-radius: 8px;
  width: 100%;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  }
}

.metric-card,
.metric-card-placeholder {
  @media only screen and (max-width: 680px) {
    min-width: 110px !important;
  }
}
</style>
